var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/time-range-basic.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-time-range\">\n    <form target=\"#\" class=\"form-horizontal cm-form\">\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("inputs"))(env, context, frame, runtime, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
output += t_1;
output += "\n    </form>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_inputs(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
output += "<div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\">From date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\" name=\"time-to\" class=\"cm-time-from-input\">\n        </div>\n        <div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\">To date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\" name=\"time-from\" class=\"cm-time-to-input\" >\n        </div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_inputs: b_inputs,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/time-range-basic.html"] , dependencies)